export const env = {
    apiKeyGoogleMap: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    urlGoogleMap: import.meta.env.VITE_GOOGLE_MAPS_URL,
    urlGoogleReview: import.meta.env.VITE_GOOGLE_REVIEW_URL,
    USER_BASIC_AUTH: import.meta.env.VITE_USER_BASIC_AUTH,
    PASSWORD_BASIC_AUTH: import.meta.env.VITE_PASSWORD_BASIC_AUTH,
    MANAGEMENT_SERVER: import.meta.env.VITE_MANAGEMENT_SERVER,
};